import * as yup from 'yup'

export const notaCreditoSchema = yup.object().shape({
  codigo: yup.number()
    .transform((value, originalValue) => originalValue === '' || originalValue === null ? undefined : value)
    .typeError('Debe ser un número')
    .positive('Debe ser un número positivo')
    .required('Código obligatorio'),
  fecha: yup.date()
    .transform((value, originalValue) => originalValue === '' || originalValue === null ? undefined : value)
    .typeError('Fecha inválida')
    .required('Fecha de emisión obligatoria'),
});

export const businessSchema = yup.object({
  selectedProductos: yup
    .array()
    .min(1, 'Debe seleccionar al menos un producto')
    .required(),
  precioNeto: yup
    .number()
    .moreThan(0, 'El precio total neto debe ser mayor a cero')
    .required('El precio total neto es obligatorio')
});